module.exports = __webpack_public_path__ + "fonts/Merriweather-300-cyrillic8.655c184.woff2";